import { clientAxios } from '@/plugins/axios'
import format from 'string-format'

const baseURL = '/v1/delivery'
const getDeliveryMethodAutoLink = `${baseURL}/delivery-method-auto`
const getDeliveryDateMinLink = `${baseURL}/{id}/delivery-date/{postal_code}/start/{pref_id}`
const getDeliveryDetailLink = `${baseURL}/detail/{id}`

export const deliveryMethod = () =>
  clientAxios.get(baseURL, {
    params: {
      visible: true,
    },
  })
export const getDeliveryTime = (id) => clientAxios.get(`${baseURL}/${id}/time`)
export const getDeliveryMethodAutoPostalCode = (params) => clientAxios.post(getDeliveryMethodAutoLink, params)
export const getDeliveryDateMin = ({ id, pref_id, postal_code }) =>
  clientAxios.get(format(getDeliveryDateMinLink, { id, pref_id, postal_code }))
export const getDeliveryDetail = (id) => clientAxios.get(format(getDeliveryDetailLink, { id }))
